var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChalkboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.571,
    height: 50,
    viewBox: "0 0 78.571 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.054,
    y1: 0.088,
    x2: 0.958,
    y2: 0.95,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34c677"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chalkboard",
    transform: "translate(-486 -2208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M4,10H75.2V54.468H4Z",
    transform: "translate(485.688 2198)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M71.636,13.557V54.468H7.56V13.557H71.636M75.2,10H4V54.468H75.2Z",
    transform: "translate(485.688 2198)",
    fill: "#dd7c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M80.571,41.375V37.688A3.642,3.642,0,0,0,77,34H5.571A3.642,3.642,0,0,0,2,37.688v3.688Z",
    transform: "translate(484 2216.625)",
    fill: "#773d04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M42.377,40.37,25.413,27.094l-11.8,8.482L11.4,32.626l14.013-9.957L41.64,35.208,57.128,16.4l2.95,2.213ZM25.413,48.852H12.506V45.164H25.413l1.844,1.844Z",
    transform: "translate(490.565 2201.772)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChalkboard);
export default __webpack_public_path__ + "static/media/chalkboard.b122144edfc144743dd72cd0ffaa399b.svg";
export { ForwardRef as ReactComponent };